import firebase from 'firebase/app';
import flamelink from 'flamelink';
import 'firebase/database';
import 'firebase/storage';

class _ExternalService {
  constructor() {
    this.apiDomain = (process.env.REACT_APP_API_BASE || '');

    this.firebaseConfig = {
      apiKey: "AIzaSyCCgaUyGZXXI_jL39lBM-3XcNQ4iJvNsTY",
      authDomain: "fir-testing-f90f4.firebaseapp.com",
      databaseURL: "https://fir-testing-f90f4.firebaseio.com",
      projectId: "fir-testing-f90f4",
      storageBucket: "fir-testing-f90f4.appspot.com",
      messagingSenderId: "252123429045",
      appId: "1:252123429045:web:1889fc01cc799481d166fc"
    };
    
    this.firebaseApp = firebase.initializeApp(this.firebaseConfig);
    // this.db = firebase.firestore();
    this.app = flamelink({firebaseApp: this.firebaseApp});

    this.dbRef = "flamelink/environments/production/content/articles/en-US";
  }

  // articles

  async getAllArticles() {
    return await this.app.content.get('articles')
      .then(async blogPosts => {
        let result = [];
        for(let key in blogPosts) {
          let { permalink, headerImage, id, summary, tags, thumbnail, title, __meta__:{createdDate}} = blogPosts[key];
          let genResponse = {
            id: id,
            title: title,
            summary: summary,
            permalink: permalink,
            tags: tags,
            images : {
              headerImage: await this.fetchImage(headerImage[0]),
              thumbnail: await this.fetchImage(thumbnail[0])
            },
            date: new Date(createdDate).toDateString()
          };

          result.push(genResponse);
        }
        // console.log(result);
        return result;
      })
      .catch(error => console.error('Something went wrong while retrieving all the content. Details:', error));
  }

  async getLatestArticles() {
    return await this.app.content.get('articles')
      .then(async blogPosts => {
        let result = [];
        for(let key in blogPosts) {

          if(result.length < 3) {
          let { headerImage, permalink, id, summary, tags, thumbnail, title, __meta__:{createdDate}} = blogPosts[key];
          let genResponse = {
            id: id,
            title: title,
            permalink: permalink,
            summary: summary,
            tags: tags,
            images : {
              headerImage: await this.fetchImage(headerImage[0]),
              thumbnail: await this.fetchImage(thumbnail[0])
            },
            date: new Date(createdDate).toDateString()
          };

          result.push(genResponse);
         } else {
           break;
         }
        }
        // console.log(result);
        return result;
      })
      .catch(error => console.error('Something went wrong while retrieving all the content. Details:', error));
  }

  async getArticleById(articleId) {
    return await this.app.content.getByField('articles', 'permalink', articleId)
      .then(async blogPosts => {
        let result = [];
        for(let key in blogPosts) {
            let { content, headerImage, permalink, id, summary, tags, thumbnail, title, __meta__:{createdDate}} = blogPosts[key];
              let genResponse = {
                id: id,
                title: title,
                permalink: permalink,
                content: content,
                summary: summary,
                tags: tags,
                images : {
                  headerImage: await this.fetchImage(headerImage[0]),
                  thumbnail: await this.fetchImage(thumbnail[0])
                },
                date: new Date(createdDate).toDateString()
              };
    
              result.push(genResponse);
            
        }
        return result;
      })
      .catch(error => console.error('Something went wrong while retrieving all the content. Details:', error));
  }

  async getRelatedArticlesByTag(refTags) {
    return await this.app.content.get('articles')
      .then(async blogPosts => {
        let result = [];
        for(let key in blogPosts) {
          if(result.length < 3) {
            let { headerImage, permalink, id, summary, tags, thumbnail, title, __meta__:{createdDate}} = blogPosts[key];

            if(refTags.some(r=>tags.indexOf(r) >=0)) {
              let genResponse = {
                id: id,
                title: title,
                permalink: permalink,
                summary: summary,
                tags: tags,
                images : {
                  headerImage: await this.fetchImage(headerImage[0]),
                  thumbnail: await this.fetchImage(thumbnail[0])
                },
                date: new Date(createdDate).toDateString()
              };
    
              result.push(genResponse);
            }
            
           } else {
             break;
           }
        }
        // console.log(result);
        return result;
      })
      .catch(error => console.error('Something went wrong while retrieving all the content. Details:', error));
  }

  async fetchImage(fileId) {
    return await this.app.storage.getURL(fileId)
    .then(url => url)
    .catch(error => console.log(error));
  }

  // gallery | case studies

  async getAllCaseStudies() {
    return await this.app.content.get('casestudies')
      .then(async caseStudy => {
        let result = [];
        for(let key in caseStudy) {
          let { title, clientName, permalink, headerImage, id, summary, tags, thumbnail, __meta__:{createdDate}} = caseStudy[key];
          let genResponse = {
            id: id,
            title: title,
            summary: summary,
            permalink: permalink,
            tags: tags,
            clientName: clientName,
            images : {
              headerImage: await this.fetchImage(headerImage[0]),
              thumbnail: await this.fetchImage(thumbnail[0])
            },
            date: new Date(createdDate).toDateString()
          };

          result.push(genResponse);
        }
        // console.log(result);
        return result;
      })
      .catch(error => console.error('Something went wrong while retrieving all the content. Details:', error));
  }

  async getLatestCaseStudies() {
    return await this.app.content.get('casestudies')
      .then(async caseStudy => {
        let result = [];
        for(let key in caseStudy) {

          if(result.length < 3) {
          let { title, clientName, permalink, headerImage, id, summary, tags, thumbnail, __meta__:{createdDate}} = caseStudy[key];
          let genResponse = {
            id: id,
            title: title,
            summary: summary,
            permalink: permalink,
            tags: tags,
            clientName: clientName,
            images : {
              headerImage: await this.fetchImage(headerImage[0]),
              thumbnail: await this.fetchImage(thumbnail[0])
            },
            date: new Date(createdDate).toDateString()
          };

          result.push(genResponse);
         } else {
           break;
         }
        }
        // console.log(result);
        return result;
      })
      .catch(error => console.error('Something went wrong while retrieving all the content. Details:', error));
  }

  async getCaseStudyById(articleId) {
    return await this.app.content.getByField('casestudies', 'permalink', articleId)
      .then(async caseStudy => {
        let result = [];
        for(let key in caseStudy) {
            let { content, clientName, headerImage, id, tags, title, __meta__:{createdDate}} = caseStudy[key];
              let genResponse = {
                id: id,
                title: title,
                content: content,
                clientName: clientName,
                tags: tags,
                images : {
                  headerImage: await this.fetchImage(headerImage[0])
                },
                date: new Date(createdDate).toDateString()
              };
    
              result.push(genResponse);
            
        }
        return result;
      })
      .catch(error => console.error('Something went wrong while retrieving all the content. Details:', error));
  }
}

const ExternalService = new _ExternalService();
export default ExternalService;